import { warning,blue } from '../../../utils/sitecolors'

export default 
{
	notFound: {
		color:warning,
		fontSize:'115%',
		paddingLeft:'30px' 
	},
	tableHeader: { 
		textAlign:'left',
		backgroundColor:'white'
	},
	saveButton: { 
		marginTop:'10px',
		color:blue 
	},
	scoresDiv: { 
		marginTop:'10px', 
		border:'1px solid #D3D3D3', 
		padding:'7px' 
	}

}


// WEBPACK FOOTER //
// ./src/components/pages/Event/styles.js